import { render, staticRenderFns } from "./long.vue?vue&type=template&id=65e99406&scoped=true"
import script from "./long.vue?vue&type=script&lang=js"
export * from "./long.vue?vue&type=script&lang=js"
import style0 from "./long.vue?vue&type=style&index=0&id=65e99406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e99406",
  null
  
)

export default component.exports